module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-700.8a4e0d0d.svg";